import icons from "../../img/icon/icons";
import styles from "./MarkerPreView.module.css";
import { markerInfoType } from "./CreateMap";

interface MarkerPreViewProps {
    exampleData: string[];
    markerInfo: markerInfoType;
}

/**
 * @author cjs
 * @date 2024-09-12 11:21:47
 * @remark 지도만들기 마커 설정 미리보기 컴포넌트
 * @pram props
 * @props MarkerPreViewProps
 *      exampleData(required) : 마커 설정과 장소 정보 설정에 미리 보여주기 위한 예제 데이터
        markerInfo(required) : 마커 설정한 데이터
    @returns MarkerPreView
 */

function MarkerPreView(props: MarkerPreViewProps) {
    const marker = props.markerInfo.markerInfo[props.markerInfo.groupIdx]
        ? props.markerInfo.markerInfo[props.markerInfo.groupIdx].marker
        : "markerSelect1";
    const color = props.markerInfo.markerInfo[props.markerInfo.groupIdx]
        ? props.markerInfo.markerInfo[props.markerInfo.groupIdx].markerColor
        : "#ba2022";

    const divStyle = {
        width: "13rem",
        height: "13rem",
        padding: "5rem",
        WebkitMaskImage: `url('${icons[marker]}')`,
        maskImage: `url('${icons[marker]}')`,
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: "center center",
        WebkitMaskPosition: "center center",
        maskSize: "14rem",
        WebkitMaskSize: "14rem",
        backgroundColor: color,
    };

    return (
        <div className={styles.wrapMarker}>
            <div style={divStyle}></div>
            <p className={styles.makerName}>{props.markerInfo.fieldNameIdx === -1 ? "" : props.exampleData[props.markerInfo.fieldNameIdx]}</p>
        </div>
    );
}

export default MarkerPreView;
